// extracted by mini-css-extract-plugin
export default {"ratingList":"RatingList_ratingList__vUdhA"};